import { css } from '@emotion/core';
import { variables, rgba, media } from '@domain-group/fe-brary';
var colour = variables.colour;
export var container = /*#__PURE__*/css(media('>=tablet'), "{display:none;}");
export var searchContainer = /*#__PURE__*/css("padding:0 14px;margin-top:29px;box-shadow:0 6px 7px 0 ", rgba(colour.black, 0.05), ";");
export var tabWrapper = {
  name: "10fu8yd",
  styles: "display:flex;justify-content:center;> .listing-type-tab{padding:12px 15px 8px;margin:0;}"
};